import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import api from "../lib/api";

const SiteDataContext = createContext(null);

export const SiteDataProvider = ({ children }) => {
  const [siteContent, setSiteContent] = useState(null);
  const [services, setServices] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const [scRes, svRes, gaRes, clRes] = await Promise.all([
        api.get("/site-content"),
        api.get("/services"),
        api.get("/gallery"),
        api.get("/clients"),
      ]);
      setSiteContent(scRes.data);
      setServices(svRes.data);
      setGallery(gaRes.data);
      setClients(clRes.data);
    } catch (e) {
      // swallow — fall back to defaults
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteDataContext.Provider
      value={{ siteContent, services, gallery, clients, loading, refresh }}
    >
      {children}
    </SiteDataContext.Provider>
  );
};

export const useSiteData = () => {
  const ctx = useContext(SiteDataContext);
  if (!ctx) throw new Error("useSiteData must be inside SiteDataProvider");
  return ctx;
};

// Helper: pick locale-specific text from a {en, ar} object
export const useLocaleText = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith("ar") ? "ar" : "en";
  const pick = (val) => {
    if (!val) return "";
    if (typeof val === "string") return val;
    return val[lang] || val.en || val.ar || "";
  };
  const pickList = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val;
    return val[lang] || val.en || val.ar || [];
  };
  return { lang, pick, pickList };
};
